import moment from 'moment';

import constants from '../../ahm-constants';

/**
 * @param {string=} dateOfBirth - A customer's dateOfBirth.
 *
 * @returns {number|null} - The age of the customer.
 */
const calculateAgeFromDateOfBirth = (dateOfBirth?: string) => {
  if (!dateOfBirth) {
    return null;
  }
  const dateOfBirthMoment = moment(dateOfBirth, constants.DATE_FORMAT.STANDARD);
  return moment().diff(dateOfBirthMoment, 'years');
};

export default calculateAgeFromDateOfBirth;
